module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_6000.7a3a3f8d.png";